import { createContext, useCallback, useState, ReactNode } from 'react'

export const WithContentsContext = createContext<{
  withContents: boolean
  setWithContents: (value: boolean) => void
} | null>({
  withContents: true,
  setWithContents: () => {},
})

export const WithContentsProvider = ({
  children,
  initialWithContents = true,
}: {
  children: ReactNode
  initialWithContents?: boolean
}) => {
  const [withContents, setWithContents] = useState(initialWithContents)
  const setWithContentsCallback = useCallback(
    (value: boolean) => setWithContents(value),
    []
  )

  return (
    <WithContentsContext.Provider
      value={{ withContents, setWithContents: setWithContentsCallback }}
    >
      {children}
    </WithContentsContext.Provider>
  )
}
